export default __webpack_public_path__ + "static/media/promoteImg5.311379f7.png";